<template>
  <div class="boxsizing tag-group-wrap auto">
    <div class="tag-group-header auto" ref="tag-group-width">
      <p>标签组</p>
      同一色系上的标签卡片代表为同一组标签，计算时可拖拽至同一组内进行计算
    </div>
    <div class="tag-group-content tag-group-group-scroll" v-if="draggable">
      <div class="tag-group-group auto boxsizing" v-show="item.value.length" v-for="(item, index) in chooseVal" :key="index">
        <draggable v-if="chooseVal[index]" :list="chooseVal[index]['value']" :group="{name: 'item',pull: 'clone', put: false}">
          <div class="tag-group-item auto boxsizing" v-for="(item2, index2) in item.value" :key="index2">
            <div class="item-title auto"><i></i>{{item2.title}}</div>
            <div class="item-child-list auto ellipsis boxsizing">{{item2.desc}}</div>
            <div class="item-text auto" v-if="item2.value.defaultTagTypeView === 'dateRange'">
              {{item2.value.values[0]}} 至 {{item2.value.values[1]}}
            </div>
            <div class="item-text auto" v-else-if="item2.value.tagTypeView === 'range'">
              &gt;={{item2.value.values[0]}}，&lt;={{item2.value.values[1]}}
            </div>
            <div class="item-text auto" v-else-if="item2.value.tagTypeView === 'string'">
              {{Array.isArray(item2.value.values) ? item2.value.values.join('/') : item2.value.values}}
            </div>
            <div class="item-text auto" v-else>{{item2.name}}</div>
            <div class="item-bot auto">标签受众源</div>
          </div>
        </draggable>
      </div>
    </div>
    <div class="tag-group-content auto" v-else>
      <div class="tag-group-group auto boxsizing" v-show="item.value.length" v-for="(item, index) in chooseVal" :key="index">
        <div class="tag-group-item auto boxsizing" v-for="(item2, index2) in item.value" :key="index2">
          <span @click="deleteItem(index, index2)" class="delete-icon auto"></span>
          <div class="item-title auto"><i></i>{{item2.title}}</div>
          <div class="item-child-list auto ellipsis boxsizing">{{item2.desc}}</div>
          <div class="item-text auto" v-if="item2.value.defaultTagTypeView === 'dateRange'">
            {{item2.value.values[0]}} 至 {{item2.value.values[1]}}
          </div>
          <div class="item-text auto" v-else-if="item2.value.tagTypeView === 'range'">
            &gt;={{item2.value.values[0]}}，&lt;={{item2.value.values[1]}}
          </div>
          <div class="item-text auto" v-else-if="item2.value.tagTypeView === 'string'">
            {{Array.isArray(item2.value.values) ? item2.value.values.join('/') : item2.value.values}}
          </div>
          <div class="item-text auto" v-else>{{item2.name}}</div>
          <div class="item-bot auto">标签受众源</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  name: 'JdFiltersTagGroup',
  display: "Clone",
  props: [
    'value',
    'draggable'
  ],
  data () {
    return {
      chooseVal: {}
    }
  },
  watch: {
    'value': function (val) {
      this.chooseVal = JSON.parse(JSON.stringify(val))
    }
  },
  components: {
    draggable
  },
  methods: {
    deleteItem (index, index2) {
      this.chooseVal[index]['value'].splice(index2, 1)
      this.$emit('getChooseVal', this.chooseVal)
    }
  },
  mounted () {
  },
  created () {
    this.chooseVal = this.value
  }
}
</script>

<style scoped>
.tag-group-wrap {
  width: 100%;
  background: #f9f9f9;
  padding: 20px;
  font-size: 12px;
  color: rgba(23,35,61,.55);
}
.tag-group-header {
  font-size: 12px;
  color: #999;
}
.tag-group-header p {
  font-size: 14px;
  color: #333;
}
.tag-group-group {
  padding: 10px 10px 0;
  border-radius: 5px;
  background: #e4e4e4;
  cursor: pointer;
  -webkit-transition: all .8s;
  transition: all .8s;
  margin-top: 10px;
}
.tag-group-group:hover {
  background: #5AA7F7;
}
.tag-group-item {
  box-shadow: 0 1px 2px 0 rgba(23,35,61,.25);
  -webkit-box-shadow: 0 1px 2px 0 rgba(23,35,61,.25);
  border-radius: 4px 4px 10px 10px;
  background: #fff;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
  padding-top: 10px;
  max-width: 180px;
}
.item-title {
  position: relative;
  padding-left: 10px;
  margin: 0 20px 0 10px;
  line-height: 16px;
}
.item-title i {
  display: block;
  width: 2px;
  height: 15px;
  background-image: linear-gradient(-135deg,#7061ef,#4d77f4);
  left: 0;
  top: 0;
  overflow: hidden;
  position: absolute;
}
.item-text {
  font-size: 14px;
  color: #333;
  padding: 5px 20px 0 20px;
}
.item-bot{
  height: 30px;
  line-height: 30px;
  text-indent: 20px;
  background: #f7f5f6;
  margin-top: 15px;
}
.item-child-list {
  width: 100%;
  height: 24px;
  line-height: 24px;
  padding: 0 20px 0 20px;
  margin-top: 10px;
}
.delete-icon {
  position: absolute;
  right: 10px;
  top: 5px;
}
.delete-icon::before {
  content: "x";
}
.tag-group-group-scroll {
  overflow-y: auto;
  height: calc(100vh - 420px);
}
</style>
